// @greenlight-spec: 22-nfrs.md

/** Hot-path performance targets (ms) from docs/22-nfrs. */
export const PERF_TARGETS = {
  authCheckMs: 30,
  dataProxyMs: 75,
  mcpToolMs: 300,
} as const;
